import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { assets } from '../../core/constants/assets.const';
import { TranslatePipe } from '../../core/pipes/translate.pipe';

@Component({
  selector: 'logibids-admin-sos',
  imports: [ButtonModule, TranslatePipe],
  templateUrl: './admin-sos.component.html',
  styleUrl: './admin-sos.component.scss',
})
export class AdminSosComponent {
  assetsConst = assets;

  constructor(
    public config: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef
  ) {}

  btn_accept(): void {
    this.dialogRef.close('yes');
  }

  btn_close(): void {
    this.dialogRef.close('no');
  }
}
